<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.279 21.334">
        <path d="M3.504 0C1.577 0 0 1.6 0 3.557v14.22c0 1.956 1.577 3.557 3.504 3.557h17.514c1.926 0 3.503-1.6 3.503-3.557v-1.226l7.497 3.804a.941.941 0 00.384.088.832.832 0 00.455-.123.93.93 0 00.422-.763V1.777a.93.93 0 00-.422-.763.837.837 0 00-.84-.037l-7.496 3.806V3.557C24.521 1.6 22.944 0 21.018 0zm0 1.777h17.514c.963 0 1.752.801 1.752 1.78v14.22c0 .979-.79 1.78-1.752 1.78H3.504c-.963 0-1.752-.801-1.752-1.78V3.557c0-.979.789-1.78 1.752-1.78zm28.023 1.44v14.898l-7.006-3.554V6.773z"/>
    </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
